/* ===========================================================================
   WARA likes UI. Holds ZERO storage knowledge — every read and write goes
   through window.WARAStore (assets/wara-account-store.js), which Session C
   swaps for a customer-metafield backend.

   Liked state cannot be server-rendered, so every like control ships neutral
   from Liquid and is painted here. Hydration has to reach controls that arrive
   after first paint — Load More appends and the filter ajax swap — which is why
   WCG.initCard calls hydrate(card) and why the click handler is delegated at
   document level instead of bound per button.

   Controls opt in with data-wara-like="<product handle>". Optional attributes:
     data-wara-like-name    product title, for the aria-label
     data-wara-like-label   child element whose text swaps between
                            data-label-off / data-label-on (PDP only; cards
                            are icon-only)
     data-wara-like-count   any element that should show the saved count
   =========================================================================== */
(function () {
  'use strict';

  var SEL = '[data-wara-like]';

  function store() { return window.WARAStore; }

  function paint(btn, liked) {
    btn.classList.toggle('is-liked', liked);
    btn.setAttribute('aria-pressed', liked ? 'true' : 'false');

    var label = btn.querySelector('[data-wara-like-label]');
    if (label) {
      var next = liked ? label.getAttribute('data-label-on') : label.getAttribute('data-label-off');
      if (next) label.textContent = next;
    }

    var name = btn.getAttribute('data-wara-like-name') || 'this piece';
    btn.setAttribute('aria-label', liked ? ('Remove ' + name + ' from saved') : ('Save ' + name));
  }

  // Accepts a control, or any ancestor of one (a card, or document).
  function collect(root) {
    var scope = root || document;
    var out = [];
    if (scope.matches && scope.matches(SEL)) out.push(scope);
    if (scope.querySelectorAll) {
      var found = scope.querySelectorAll(SEL);
      for (var i = 0; i < found.length; i++) out.push(found[i]);
    }
    return out;
  }

  function hydrate(root) {
    var s = store();
    if (!s) return;
    var btns = collect(root);
    for (var i = 0; i < btns.length; i++) {
      paint(btns[i], s.likes.hasSync(btns[i].getAttribute('data-wara-like')));
    }
  }

  function refreshCounts() {
    var s = store();
    if (!s) return;
    var n = s.likes.countSync();
    var nodes = document.querySelectorAll('[data-wara-like-count]');
    for (var i = 0; i < nodes.length; i++) {
      nodes[i].textContent = n;
      nodes[i].classList.toggle('is-visible', n > 0);
    }
  }

  /* CAPTURE phase on document, same rationale as quick-add in wara-card.js:
       1. it runs before the card's bubble-phase drag guard, so stopPropagation
          keeps a like from ever being read as a swipe;
       2. preventDefault stops the enclosing <a> navigating to the PDP.
     Delegation is what makes Load-More and ajax-swapped cards work unbound. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(SEL);
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    var s = store();
    if (!s) return;

    var handle = btn.getAttribute('data-wara-like');
    if (!handle || btn.getAttribute('aria-busy') === 'true') return;

    btn.setAttribute('aria-busy', 'true');

    /* Optimistic paint. v1 storage is synchronous so this is invisible today,
       but Session C's backend will not be, and a heart that lags a tap reads as
       broken. The real result is reconciled below. */
    paint(btn, !s.likes.hasSync(handle));
    btn.classList.add('is-pulsing');
    window.clearTimeout(btn._waraPulse);
    btn._waraPulse = window.setTimeout(function () {
      btn.classList.remove('is-pulsing');
    }, 320);

    Promise.resolve(s.likes.toggle(handle)).then(function (liked) {
      paint(btn, liked);
    }).catch(function (err) {
      console.error('[wara-likes] toggle failed', err);
      paint(btn, s.likes.hasSync(handle)); // roll the optimistic paint back
    }).then(function () {
      btn.removeAttribute('aria-busy');
    });
  }, true);

  /* One listener on the store's DOM event, not its module handler — the store
     fires both, and listening to one keeps a toggle from hydrating twice.
     This is what keeps the PDP inline control, the sticky control and any card
     for the same product in agreement. */
  document.addEventListener('wara:likes:changed', function () {
    hydrate(document);
    refreshCounts();
  });

  function init() {
    hydrate(document);
    refreshCounts();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // hydrate is called by WCG.initCard; refreshCounts by the saved page.
  window.WARALikes = { hydrate: hydrate, refreshCounts: refreshCounts };
})();
